import React, { Component } from 'react'
import { Table, Button } from 'reactstrap';
import ModalForm from '../Modals/Modal';
import axios from 'axios';

class DataTable extends Component {

  deleteItem = id => {
    let confirmDelete = window.confirm('Delete item forever?')
    if(confirmDelete){
      try {
        const params = {
          id: id
        };
        axios.delete(`https://t2qaedohf6.execute-api.us-east-1.amazonaws.com/stud/studiobo/${id}`, params)
          // .then(response => response.json())
          .then(res => {
            if (res.status == '204') {  
              console.log("res", res.status);
              window.location.reload();
            } else {
              console.log('failure')
            }
          })
      }
      catch (err) {
        console.log(err);
      }
    }

  }

  render() {
   const maxlimit = 50;
    const items = this.props.items.map(item => {
      return (
        <tr key={item.id}>
          
          <th scope="row">{ ((item.email).length > maxlimit) ? 
            (((item.email).substring(0,maxlimit-3)) + '...') : 
            item.email }</th>
          <td>{item.id}</td>
          <th scope="row">{ ((item.privateKey).length > maxlimit) ? 
            (((item.privateKey).substring(0,maxlimit-3)) + '...') : 
            item.privateKey }</th>
          <td>
            <div style={{width:"110px"}}>
              <ModalForm buttonLabel="Edit" item={item} updateState={this.props.updateState}/>
              {' '}
              <Button color="danger" onClick={() => this.deleteItem(item.id)}>Del</Button>
            </div>
          </td>
        </tr>
        )
      })

    return (
      <Table responsive hover>
        <thead>
          <tr>
            <th>Email</th>
            <th>ID</th>
            <th >PrivateKey</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {items}
        </tbody>
      </Table>
    )
  }
}

export default DataTable